export const layoutConstants = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR'
};
